import env from '@polleverywhere/core/lib/env'
import URI from 'urijs'

export default function absoluteApiUrl ({ path, search }) {
  const absoluteUrl = env.get('api_url').clone().path(path).search(search || false)

  if (env.get('nginx_proxy_path')) {
    const url = absoluteUrl.clone()
    url.resource(env.get('nginx_proxy_path') + url.resource())
    url.origin(URI().origin())
    return url.toString()
  }

  return absoluteUrl.toString()
}
